'use client';

import type { ProductUnitItem } from '@weberus/shared-types';
import { cn } from '@/app/_shared/utils/tw-cn';
import { ProductUnit, ProductUnitType } from '@/app/_components/feature/product-unit';
import { convertToProductUnitProps } from '@/app/_components/feature/product-unit/converter';

export const ProductUnitGroup = ({
  items,
  onImpression,
  listPosition,
  onClick,
}: {
  items: ProductUnitItem[];
  listPosition: number;
  onImpression?: (item: ProductUnitItem, index: number, listPosition: number) => void;
  onClick?: (item: ProductUnitItem, index: number, listPosition: number) => void;
}) => {
  if (!items.length) return null;

  return (
    <div
      className={cn(
        // 레이아웃
        'flex w-full max-w-legacy-pc-size flex-wrap pc:rounded-12',
        // 보더 + 구분자
        'divide-y divide-line-neutral-weak1 overflow-hidden border-b border-t border-line-neutral-weak1 pc:divide-x pc:border pc:first:!border-t pc:[&>*:nth-child(2)]:!border-t-0 pc:[&>*:nth-child(2n+1)]:!border-l-0',
      )}>
      {items.map((item, index) => {
        return (
          <ProductUnit
            key={item.data.id}
            type={item.type === 'PRODUCT_ITEM' ? ProductUnitType.LIST : ProductUnitType.BANNER}
            url={item.data?.action?.web}
            onImpression={() => onImpression?.(item, index, listPosition)}
            onItemClick={() => onClick?.(item, index, listPosition)}
            {...convertToProductUnitProps(item)}
          />
        );
      })}
      {/* 그룹이 홀수일 경우, divide 스타일 적용이 안되므로 임의의 아이템 추가 */}
      {!!(items.length % 2) && <div className="hidden w-full pc:block pc:w-1/2" />}
    </div>
  );
};
